import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  TeacherProfile,
  UpdateTeacherProfileInput,
  RegisterTeacherInput,
  RegisterTeacherResponse,
} from '@/types/teacher';

export async function registerTeacher(input: RegisterTeacherInput): Promise<RegisterTeacherResponse> {
  const { data } = await client.post<ApiResponse<RegisterTeacherResponse>>(
    '/api/v1/teachers/register',
    input,
  );
  return data.data;
}

export async function getProfile(): Promise<TeacherProfile> {
  const { data } = await client.get<ApiResponse<TeacherProfile>>('/api/v1/teachers/profile');
  return data.data;
}

export async function updateProfile(input: UpdateTeacherProfileInput): Promise<TeacherProfile> {
  const { data } = await client.put<ApiResponse<TeacherProfile>>(
    '/api/v1/teachers/profile',
    input,
  );
  return data.data;
}
